import { render, staticRenderFns } from "./DownloadDBC.vue?vue&type=template&id=690bae05&scoped=true&"
import script from "./DownloadDBC.vue?vue&type=script&lang=ts&"
export * from "./DownloadDBC.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadDBC.vue?vue&type=style&index=0&id=690bae05&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690bae05",
  null
  
)

export default component.exports